import { connect } from 'react-redux'
import More from './More.jsx'
import { updateCollaborativeIndexationFieldValue } from 'redux/collaborativeIndexations/actions'
import { getCollaborativeIndexationCreationFields } from 'redux/collaborativeIndexations/selectors'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value))
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const MoreContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(More)
